module.exports = __webpack_public_path__ + "img/51.73b9ead4.png";